import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { DfModalService } from '@df/ui/modal/df-modal.service';

export interface IDfCmsModalConfig extends Omit<NDfModal.IModalConfig, 'component' | 'type'> {
    name: string;
    // if provided we will use the value to inform why you cant open it in cms
    cmsNonOpenable?: string;
}

/**
 * Rewgisters CMS component as modal
 */
export function DfCmsModal(config: IDfCmsModalConfig) {
    return (component): any => {
        DfModalService.register({ component, ...config, type: 'cmsmodal' });
        return component;
    };
}
